
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/colossus",
      function () {
        return require("private-next-pages/colossus/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/colossus"])
      });
    }
  